import React, { Suspense } from 'react';
import Container from '../components/shared/container/Container';
import CommonLoader from '../components/shared/loaders/CommonLoader';
import PageTitle from '../components/shared/page/PageTitle';
import PageTitleContainer from '../components/shared/page/PageTitleContainer';
import UsersHeader from '../components/users/UsersHeader';
import UsersList from '../components/users/UsersList';
import UsersPagination from '../components/users/UsersPagination';
import useFetchRoles from '../hooks/roles/useFetchRoles';

const Users = () => {
  const { loading } = useFetchRoles();

  return (
    <Suspense fallback={<CommonLoader />}>
      <section>
        <PageTitleContainer>
          <PageTitle title={'Користувачі'} />
        </PageTitleContainer>
        {loading ? (
          <CommonLoader />
        ) : (
          <Container>
            <UsersHeader />
            <UsersList />
            <UsersPagination />
          </Container>
        )}
      </section>
    </Suspense>
  );
};

export default Users;
